export const participacaoOptions = {
		series: [],
		chart: {
			type: "donut",
			width: '100%',
			height: 300,
			redrawOnParentResize: true,
    		redrawOnWindowResize: true,
		},
		noData: {
			text: 'Sem Dados', 
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
				color: undefined,
				fontSize: '14px',
				fontFamily: undefined
			}
			},
		tooltip: {
			custom: (seriesName) => {
				const totalVal = seriesName.series.reduce((ac, val) => {
					ac += val;
					return ac;
				});
				const innerValue = GLOBAL.FormatREAL(
					`${seriesName.series[seriesName.seriesIndex]}`
				);
				const currentValue = seriesName.series[seriesName.seriesIndex];
				const currentIndex = seriesName.seriesIndex;
				const colorsChart = seriesName.w.globals.fill.colors;
				return `<div class="p-12 bg-white">
                        <p class="flex items-center gap-4 font-semibold text-neutral-80"><span class="block w-10 h-10 rounded-full " style="background: ${colorsChart[currentIndex]
					}"></span> ${seriesName.w?.config?.labels[seriesName.seriesIndex]
					}</p>
                        <span class="text-neutral-70">${Number(
						(currentValue / totalVal) * 100
					).toFixed(1)}% - R$ ${innerValue}</span>
                    </div>`;
			},
			y: {
				formatter: undefined,
				title: {
					formatter: (seriesName) => seriesName,
				},
			},
		},
		dataLabels: {
			enabled: true,
			formatter: function (val, opts) {
				//console.log(val, opts);
				return new Intl.NumberFormat('pt-br').format(opts.w.config.series[opts.seriesIndex])
				// return new Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(opts.w.config.series[opts.seriesIndex])
			},
		},
		colors: ['#D2E2F3', '#93C7FF', '#83BFFF', '#75B5F0', '#74B7FF', '#71B5FF', '#6BA4D4', '#639DD4', '#59A9FF',
			'#55A7FF', '#52A8FF', '#4FA7FF', '#46A3FF', '#459EF6', '#2D90ED', '#2A94FF', '#2793FF', '#0080FF', '#448FD6',
			'#3482CC', '#3A7DB8', '#74B7FF', '#437199', '#186EBF', '#195386', '#164A78', '#164269', '#173C5E', '#153654',
			'#153047'
		].reverse(),
		legend: {
			show: true,
			formatter: function (seriesName, opts) {
				//console.log(seriesName, opts);
				return `<div style="display:flex; align-items:center; gap: 4px">
						<span style="display: block; width: 8px; height: 8px; border-radius: 8px; background:${opts.w?.config?.colors[opts.seriesIndex]}"></span>
						<div style="width:200px; overflow:hidden;  	display:-webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical;"">${seriesName}</div>
					</div>`;
				// return [seriesName, " - ", opts.w.globals.series[opts.seriesIndex]]
			},
			markers: {
				width: 0,

				height: 0,
				strokeWidth: 0,
				strokeColor: "#fff",
				// fillColors: colors,
			},
		},
		responsive: [{
			breakpoint: 480,
			options: {
				chart: {
					type: "donut",
					height: 550,
				},
				legend: {
					position: "bottom",
					horizontalAlign: "left",
					offsetY: 8,
					formatter: function (seriesName, opts) {
						return `<div style="width:100%; overflow:hidden;  	display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical;"">${seriesName}q/div>`;
						// return [seriesName, " - ", opts.w.globals.series[opts.seriesIndex]]
					},
				},
				subtitle: {
					offsetY: 0,
				},
			},
		},],
		subtitle: {
			text: "PARTICIPAÇÃO POR FUNDO",
			offsetY: 0,
			style: {
				fontSize: "12px",
				fontWeight: "600",
				fontFamily: undefined,
				color: "#949799",
			},
		},
		stroke: {
			show: true,
			width: 0,
		},
		donut: {
			size: "10%",
		},
		fill: {
			colors: ['#D2E2F3', '#93C7FF', '#83BFFF', '#75B5F0', '#74B7FF', '#71B5FF', '#6BA4D4', '#639DD4', '#59A9FF',
				'#55A7FF', '#52A8FF', '#4FA7FF', '#46A3FF', '#459EF6', '#2D90ED', '#2A94FF', '#2793FF', '#0080FF', '#448FD6',
				'#3482CC', '#3A7DB8', '#74B7FF', '#437199', '#186EBF', '#195386', '#164A78', '#164269', '#173C5E', '#153654',
				'#153047'
			].reverse()
		},
		plotOptions: {
			pie: {
				donut: {
					size: "30%",
				},
			},
		},
	};